function text(value) {
	return typeof value === 'string' ? value.trim() : '';
}

function money(value) {
	return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

function cartFields(result) {
	if (!text(result?.code) || !text(result?.cart_id)
		|| !money(result.cart_total_before) || !money(result.cart_total_after)) return null;
	return {
		code: result.code.trim(),
		cart_id: result.cart_id.trim(),
		cart_total_before: result.cart_total_before,
		cart_total_after: result.cart_total_after,
	};
}

export function couponApplyPayloads(response, context = {}) {
	if (!['manual', 'suggested'].includes(context.origin)) return [];
	if (context.origin === 'suggested' && (!Number.isInteger(context.position) || context.position < 1)) return [];
	return (Array.isArray(response?.data?.coupon_events) ? response.data.coupon_events : []).flatMap(result => {
		const cart = cartFields(result);
		if (!cart || typeof result.success !== 'boolean') return [];
		const hasDiscount = ['percent', 'amount'].includes(result.discount_type) && money(result.discount_value)
			&& (result.discount_type !== 'percent' || result.discount_value <= 100);
		const unknownDiscount = result.discount_type == null && result.discount_value == null;
		if (!hasDiscount && !unknownDiscount) return [];
		if (!result.success && !text(result.error_reason)) return [];
		return [{
			...cart,
			origin: context.origin,
			...(context.origin === 'suggested' ? {position: context.position} : {}),
			success: result.success,
			...(!result.success ? {error_reason: result.error_reason.trim()} : {}),
			...(hasDiscount || result.success ? {discount_type: hasDiscount ? result.discount_type : null, discount_value: hasDiscount ? result.discount_value : null} : {}),
		}];
	});
}

export function couponRemovePayloads(response) {
	return (Array.isArray(response?.data?.coupon_events) ? response.data.coupon_events : []).flatMap(result => {
		const cart = cartFields(result);
		return cart && result.success === true ? [cart] : [];
	});
}

export function purchaseCouponFields(cart) {
	const tracking = cart?.tracking;
	const cartId = text(tracking?.cart_id);
	const fields = cartId ? {cart_id: cartId} : {};
	if (tracking?.discounts_complete === false) return fields;
	if (!Array.isArray(tracking?.discounts)) return fields;
	const discounts = tracking.discounts.flatMap(discount =>
		text(discount?.code) && money(discount.amount)
			? [{code: discount.code.trim(), amount: discount.amount}] : []);
	return {...fields, discounts};
}
